module.exports = __webpack_public_path__ + "static/media/primario.5e02ab47.png";